import history from "./history";
import { io } from "socket.io-client";
import { useState } from "react";
//===========================================================================================================
// STATICS
export const BaseUrlPublic = "https://api.sepandplus.ontco.com/publicapi/";
export const WebAppUrl = "https://sepandplus.ontco.com/";
export const SelfAppUrl = "https://cp.sepandplus.ontco.com/";
export const BuAppUrl = "https://bu.sepandplus.ontco.com/";
export const BaseUrlAssets = "https://api.sepandplus.ontco.com/api/public/";
//http://185.239.104.87:3039
export const ServerSocket = io("", {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 2000000000,
  reconnectionDelay: 2000,
});
// export const ServerSocket = io("https://cp.sepandplus.ontco.com", {
//   autoConnect: false,
// });

export function LogoutFunction() {
  if (!isUser) {
    localStorage.removeItem("mobile");
    localStorage.removeItem("token");
    history.push("/Login");
  } else {
    localStorage.removeItem("userName");
    localStorage.removeItem("tokenn");
    history.push("/Login/" + localStorage.getItem("code"));
  }
  ServerSocket.disconnect();
}
//===========================================================================================================

//===========================================================================================================

export const isUser = false;
export const BaseUrl = "https://api.sepandplus.ontco.com/api/";
export function Authorization() {
  let ob = {
    mobile: localStorage.getItem("mobile"),
    token: localStorage.getItem("token"),
  };

  return ob;
}

export function ClubAuthorization() {
  let ob = {
    mobile: localStorage.getItem("mobile"),
    token: localStorage.getItem("token"),
    // mod: "development",
    mod: "production",
  };

  return ob;
}

//===========================================================================================================

// export const isUser = true;
// export const BaseUrl = "https://api.sepandplus.ontco.com/buapi/";

// export function Authorization() {
//   let ob = {
//     userName: localStorage.getItem("userName"),
//     token: localStorage.getItem("tokenn"),
//   };
//   return ob;
// }

// export function ClubAuthorization() {
//   let ob = {
//     userName: localStorage.getItem("userName"),
//     token: localStorage.getItem("tokenn"),
//     // mod: "development",
//     mod: "production",
//   };

//   return ob;
// }
